var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "flex-col" }, [
    _c("small", { staticClass: "caption soli-grey" }, [
      _vm._v(_vm._s(_vm.globalMomentWeekDay(_vm.date))),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "font-weight-bold soli-grey body-1 align-self-center" },
      [
        _vm._v(
          "\n        " + _vm._s(_vm.globalMomentDateNoYear(_vm.date)) + "\n    "
        ),
      ]
    ),
    _vm._v(" "),
    _c("small", { staticClass: "caption soli-grey" }, [
      _vm._v(_vm._s(_vm.globalMomentTime(_vm.date))),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }